export const SR_MINIMUM_NAICS_CONFIDENCE = 0.9;
export const SR_MAXIMUM_POSSIBLE_DISTANCE = 100;
export const SR_MAXIMUM_OPTIMAL_DISTANCE = 50;
export const SR_MINIMUM_PRODUCT_CONFIDENCE = 0.7;
export const SR_MINIMUM_GEOGRAPHY_CONFIDENCE = 0.7;
export const SR_MINIMUM_INDUSTRY_CONFIDENCE = 0.7;
export const SR_MINIMUM_MATCH_FOUND_PERCENTAGE = 0.75;
export const SR_MINIMUM_MATCH_SCORE = 0.5;